import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { supportedApplicationLanguages } from 'locales/_languages';
import { getCurrentLanguage } from 'modules/language/selectors/language';

const propTypes = {
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

const BrowserLinkLanguageInterceptor = ({ match, location }) => {
  const parts = location.pathname.split('/');
  const current = parts[parts.length - 1];

  return !supportedApplicationLanguages.includes(match.params.language)
    ? <Redirect to={{ pathname: `/${ getCurrentLanguage() }/${ current }` }} />
    : null;
};

BrowserLinkLanguageInterceptor.propTypes = propTypes;

export default BrowserLinkLanguageInterceptor;
